//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";

const ThriveCampaign = () => {
  const { handleResponse, handleError } = HandleApiResponse();

  async function getdetails(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      };
      let query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/thrive-signature/get-thrive-campaign?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }


  async function campaignsearch(values) {
      try {
        const obj = {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json"
          },
        };
        let query;
        query = JSON.stringify(values);
        let res = await fetch(
          `${config.host}/cdr-panel/thrive-signature/campaign-search?query=${query}`,
          obj
        );
   
        return handleResponse(res);
      } catch (err) {
        handleError(err);
      }
    }
 
  


  return {
    getdetails,
    campaignsearch
    
  };
};

export default ThriveCampaign;